import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import IndexLayout from "./Layouts/IndexLayout";
import PageDetail from './Pages/PageDetail/PageDetail';
import PageProductos from "./Pages/PageProductos/PageProductos";
import PageCategorias from "./Pages/PageCategorias/PageCategorias";
//import ProductsPage from "./Components/ProductsPage/ProductsPage";
function App() {
  const ruta_servidor = "" 
  //const ruta_servidor = "/peruana"
  return (
    <div className="App">


      <Router basename={ruta_servidor} >
        <Routes>
          <Route path="/inicio" element={<IndexLayout />} />
          <Route exact path="/" element={<IndexLayout />} />
          <Route exact path="/producto/:idProducto/:name" element={<PageDetail />} />
          <Route exact path="/Productos" element={<PageProductos />} />
          <Route exact path="/categoria/:nombreCategoria" element={<PageCategorias />} />
          <Route path="*" element={<div><h2>404-no pudimos encontrar esta página</h2></div>} />
          {/* <Route exact path="/nosotros" element={<Nosotros />} />
          <Route exact path="/contacto" element={<Contacto />} />
          <Route exact path="/ayuda" element={<Ayuda />} />
          <Route exact path="/sucursales" element={<Sucursales />} />
          <Route exact path="/prueba/:name" element={<Borrar />} />
          <Route exact path="/carrito" element={<Carrito agregarItemCarro={agregarItemCarro} quitarItemCarro={quitarItemCarro} limpiarCarro={limpiarCarro} />} />
          <Route exact path="/marca/:name" element={<Marca agregarItemCarro={agregarItemCarro} />} />
          <Route exact path="/familia/:name" element={<Familia agregarItemCarro={agregarItemCarro} />} />
          <Route path="*" element={<div><h2>404-no pudimos encontrar esta página</h2></div>} />
          <Route exact path="/corporativo" element={<Corporativo />} />  */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
